var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('breadcrumb',_vm._b({style:({ order: _vm.order })},'breadcrumb',{
    colorGetter: _vm.colorGetter,
    endText: _vm.endText,
    from: _vm.fromItem,
    itemHeight: _vm.itemHeight,
    itemWidth: _vm.itemWidth,
    items: _vm.items,
    spacing: _vm.spacing,
    tailWidth: _vm.tailWidth,
    width: _vm.width
  },false))}
var staticRenderFns = []

export { render, staticRenderFns }